import { FilesModel } from "./files.model";

export class FilesViewModel { 
    storageCapacity: number;
    storageSpent: number;
    storageCapacityString: string;
    storageSpentString: string;
    totalPages: number;
    actualPage: number;
    files: FilesModel[] = [];
}
